<script lang="ts">
    import type {DyResponsePopupTextType} from 'types/dy';
    import {customer, dyData, modal} from 'general/store';
    import {priceData} from 'general/store';

    import s from './style.module.css';

    export let item: DyResponsePopupTextType = {};

    $: customerName = $customer.firstname ? `, ${$customer.firstname}` : '';
</script>

<p
    class={s.text}
    class:s.title={item.title}
    class:s.titleD={item.title && !$dyData.isMobile}
    style="
        margin-top: {item.marginTop || '0'};
        margin-bottom: {item.marginBottom || '0'};
        margin-left: {item.marginLeft || '0'};
        margin-right: {item.marginRight || '0'};
        font-size: {item.fontSize || '20px'};
        font-weight: {item.fontWeight || '400'};
        line-height: {item.lineHeight || '1.25'};
        letter-spacing: {item.letterSpacing || '0'};
        text-decoration: {item.textDecoration || 'none'};
        color: {item.color || 'inherit'};
        text-align: {item.textAlign || 'center'};
        background-color: {item.backgroundColor || 'transparent'};
        padding: {item.padding || 'transparent'};
        border-radius: {item.borderRadius || 'transparent'};
        border-top: {item.borderTop || 'transparent'}
    "
>
    {#if item.textAlt && $modal.isAltText()}
        {item.textAlt}
    {:else if item.html}
        {@html item.html}
    {:else if item.title}
        {item.title}{customerName}
    {:else if item.text}
        {item.text}
    {/if}
    {#if 'price' in item}
        {item.price || $priceData}
    {/if}
</p>
